<template>
  <div class="position-relative">
    <input
      v-debounce="lookupItems"
      debounce-events="input"
      v-model="value"
      v-on:focus="closeItemsList()"
      v-on:input="emitNewValue"
      v-on:keydown.enter="chooseItem(null)"
      v-on:keydown.esc="closeItemsList(null)"
      v-on:keydown.tab="closeItemsList(null)"
      v-on:keyup.down="selectNext()"
      v-on:keyup.up="selectPrev()"
      class="form-control form-control-sm"
      data-lpignore="true"
      :id="id"
      :placeholder="placeholder"
      type="text"
      :class="!isCleared ? backgroundColor : 'bg-white'"
    />
    <div
      v-if="showDropDown"
      class="dropdown-menu position-absolute d-block w-auto py-0"
      ref="itemsList"
    >
      <div
        v-bind:key="index"
        v-on:click.stop="chooseItem(item)"
        v-for="(item, index) in items"
        class="dropdown-item text-nowrap text-truncate"
      >
        {{ item }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../../assets/sass/custom";

.dropdown-item.active {
  background-color: $lti-secondary-bg-color;
}
.dropdown-menu {
  max-width: 300px;
}
::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #cccccc;
  opacity: 1; /* Firefox */
}
:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #cccccc;
}
::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #cccccc;
}
</style>

<script>
export default {
  data() {
    return {
      currentFocus: -1,
      highlightedItemValue: "",
      items: [],
      lockDebounce: false,
      showDropDown: false,
      value: "",
    };
  },
  emits: [
    "valueChanged", // emit data to parent
  ],
  methods: {
    chooseItem(val) {
      this.lockDebounce = true;
      if (val === null && !this.highlightedItemValue) {
        // Enter pressed to submit a search
      } else if (val === null && this.highlightedItemValue) {
        // Enter pressed to select highighlited item
        this.value = this.highlightedItemValue.trim();
        this.emitNewValue();
      } else {
        // Highlighted item clicked
        this.value = val.trim();
        this.emitNewValue();
      }
      this.closeItemsList();
    },
    closeItemsList() {
      this.currentFocus = -1;
      this.highlightedItemValue = "";
      this.items = [];
      this.showDropDown = false;
    },
    emitNewValue() {
      // update parent
      this.$emit("valueChanged", this.value);
    },
    lookupItems() {
      this.currentFocus = -1;
      if (!this.lockDebounce && this.value.length >= 3) {
        this.axios
          .get(this.url, {
            params: {
              CorpCode: this.corpCode.toUpperCase(),
              [this.urlParamName]: this.value,
            },
          })
          .then((response) => {
            this.items = response.data;
            if (this.items.length > 0) {
              this.showDropDown = true;
            } else {
              this.showDropDown = false;
            }
          });
      }
      this.lockDebounce = false;
    },
    selectNext() {
      this.currentFocus++;
      this.setActiveItem(this.currentFocus);
    },
    selectPrev() {
      this.currentFocus--;
      this.setActiveItem(this.currentFocus);
    },
    setActiveItem(n) {
      const listItems = this.$refs.itemsList.getElementsByTagName("div");
      // clear active attribute from all listItems
      for (let i = 0; i < listItems.length; i++) {
        listItems[i].setAttribute(
          "class",
          "dropdown-item text-nowrap text-truncate"
        );
      }
      // highlight active item
      listItems[n].setAttribute(
        "class",
        "dropdown-item text-nowrap text-truncate active"
      );
      // set highlightedItemValue (used when Enter key pressed!)
      this.highlightedItemValue = listItems[n].textContent;
    },
    onBlurEvent(event) {
      if (!event.target.matches(this.componentId) && this.showDropDown) {
        this.closeItemsList();
      }
    },
  },
  props: {
    corpCode: { type: String, required: true },
    id: { type: String, required: true },
    name: { type: String, required: true },
    placeholder: { type: String, required: true },
    url: { type: String, required: true },
    urlParamName: { type: String, required: true },
    backgroundColor: { type: String, required: false },
    isCleared: { type: Boolean, required: true, default: true },
    componentId: { type: String, required: true },
  },
  watch: {
    "$route.query": {
      deep: false,
      handler: function(query) {
        this.value = query[this.name] || "";
      },
      immediate: true,
    },
  },
  mounted() {
    window.addEventListener("click", this.onBlurEvent);
  },
};
</script>
